import { BattlesListItemProps } from '../BattlesListItemType';
import images from 'assets/images';
import React from 'react';
import classnames from 'classnames';
import { BattleStatus } from '../../../../../../models/battles/Battle';
import { FormattedMessage } from 'react-intl';

export type BattleListItemPlayersProps = BattlesListItemProps & { showScore?: boolean };

export const BattleListItemPlayers = ({ showScore, currentPlayer, opponent, battle }: BattleListItemPlayersProps) => {
	return (
		<div className="d-flex  flex-column pb-3">
			<div className="d-flex flex-row justify--between mb-2">
				{!!currentPlayer && (
					<div className="position-relative tile__player">
						<div
							className="tile__image rounded-circle background-image size--cover"
							style={{
								backgroundImage: `url(${currentPlayer.avatar || images.default.avatar.user})`,
							}}
							title={`${currentPlayer.firstname} ${currentPlayer.surname}`}
						/>
						{!!showScore && (
							<div
								className={classnames('tile__score tile__score--left font-weight-bold fs-3 fs-md-4', {
									'tile__score--winner': currentPlayer.score > (opponent?.score || 0),
								})}
							>
								{currentPlayer.originalScore === null ? '-' : currentPlayer.score}
							</div>
						)}
					</div>
				)}
				<div
					className={classnames('d-flex flex-column', {
						'align-self-end': battle.status !== BattleStatus.RESOLVED,
					})}
				>
					{battle.status === BattleStatus.RESOLVED ? (
						<>
							<div className="text-center tile__color--gray">
								<FormattedMessage id={`battle-list.status.resolved.resolvedDate`} />
							</div>
							<div className="text-center">{battle.resolveDate.format('L')}</div>
							<div className="text-center">{battle.resolveDate.format('LT')}</div>
						</>
					) : (
						<div className="tile__color--gray">vs</div>
					)}
				</div>
				{!!opponent && (
					<div className="position-relative tile__player">
						<div
							className="tile__image rounded-circle background-image size--cover"
							style={{
								backgroundImage: `url(${opponent.avatar || images.default.avatar.user})`,
							}}
							title={`${opponent.firstname} ${opponent.surname}`}
						/>
						{!!showScore && (
							<div
								className={classnames('tile__score tile__score--right font-weight-bold fs-3 fs-md-4', {
									'tile__score--winner': opponent.score > (currentPlayer?.score || 0),
								})}
							>
								{opponent.originalScore === null ? '-' : opponent.score}
							</div>
						)}
					</div>
				)}
			</div>
			<div className="d-flex flex-row justify--between">
				{!!currentPlayer && (
					<div className="d-flex flex-column">
						<div className="font-weight-bold">{currentPlayer.firstname}</div>
						<div className="tile__color--gray">{currentPlayer.localisations}</div>
					</div>
				)}
				{!!opponent && (
					<div className="d-flex flex-column">
						<div className="text-right font-weight-bold">{opponent.firstname}</div>
						<div className="text-right tile__color--gray">{opponent.localisations}</div>
					</div>
				)}
			</div>
		</div>
	);
};
